import React, { Component } from 'react';
import { connect } from 'react-redux';
import SwarmColonyDataTable from '@lesofi/swarmcolony-datatable'
import * as actions from '../../redux/imgSegment/actions';

const columnData = [
    { id: 'task_seq', numeric: false, disablePadding: false, label: 'Frame No.', customCol: false, style: { paddingLeft: '5px',paddingRight: '1px', width: '10%'}, noHeader: false },
    { id: 'answer_segmented_img_url', numeric: false, disablePadding: true, label: 'Segmented Images', customCol: true, style: { paddingLeft: '10px', paddingRight: '10px',  width: '17%'},noHeader: false },
    { id: 'answer_img_obj_na', numeric: false, disablePadding: true, label: 'Answers(No more object)', customCol: true, style: { paddingLeft: '11px', paddingRight: '11px',  width: '17%'},noHeader: false },
    { id: 'answer_img_not_load', numeric: false, disablePadding: true, label: 'Answers(Image not load)', customCol: true, style: { paddingLeft: '11px', paddingRight: '11px',  width: '17%'},noHeader: false },
    { id: 'status', numeric: false, disablePadding: true, label: 'Status', customCol: false, style: { paddingLeft: '11px', paddingRight: '11px',  width: '16%'},noHeader: false },
    { id: 'submitted_at', numeric: false, dateFormat: { format: 'DD-MMM-YYYY HH:mm:ss a' }, disablePadding: true, label: 'Submitted At',style: { paddingLeft: '11px', paddingRight: '11px',width: '22%' },noHeader: false }
];

const customCol = (col,row,props)=>{
    switch(col.id){
        case 'answer_segmented_img_url':
            if (row.answer_img_obj_na || row.answer_img_not_load){
                return (
                    <span style={{color: 'black'}}>Not Available</span>
                )
            }
            return (
                <a href={row.answer_segmented_img_url} target='_blank' >
                    <span style={{color: 'black'}}>View Segmented Image</span>
                </a>
            )
        case 'answer_img_obj_na': 
            return (
                <span style={{color: 'black'}}>{row.answer_img_obj_na?'Yes':'No'}</span>
            )   
        case 'answer_img_not_load': 
            return (
                <span style={{color: 'black'}}>{row.answer_img_not_load?'Yes':'No'}</span>
            )        
        default:
    }
}

class ImageSegmentAckTaskContinue extends Component {

    componentWillMount(){
        const { imgSegment } = this.props;
        const { taskAccessKey,query } = imgSegment;
       
        if (query && taskAccessKey){
            const { jwt } = query;
            this.props.getCurrentSegmentQuestion(jwt,taskAccessKey);
        }
    }

    componentDidMount(){
        const { imgSegment } = this.props;
        const { imgSegmentQuestion,query } = imgSegment;
        
        if (imgSegmentQuestion && query){
            const { jwt } = query;
            this.props.getNextImageSegmentDataset(jwt,imgSegmentQuestion.id);
            this.refreshWorkerAnswers()
        }
    }

    refreshWorkerAnswers(){
        const { imgSegment } = this.props;
        const { imgSegmentQuestion,query } = imgSegment;

        if (imgSegmentQuestion && query){
            const { jwt } = query;
            this.props.getImgSegmentDatasets(jwt,imgSegment.page,imgSegment.pageSize,imgSegment.sortField,imgSegment.sortOrder,imgSegmentQuestion.id);
        }
    }

    handleChangePage = (event, page) => {
        const nextPage=page+1;    
        const { imgSegment } = this.props;
        const { query } = imgSegment;
        this.props.setPage(query.jwt,imgSegment,nextPage);
    };
  
    handleChangeRowsPerPage = event => {
        const pageSize=event.target.value;
        const { imgSegment } = this.props;
        const { query } = imgSegment;
        this.props.setPageSize(query.jwt,imgSegment,pageSize);
    };

    handleRequestSort = (event, property) => {
        let order = 'desc';
        const { imgSegment } = this.props;
        const { query,sortField,sortOrder } = imgSegment;
        
        if (sortField === property && sortOrder === 'desc') {
            order = 'asc';
        }
        
        this.props.sortData(query.jwt,imgSegment,property,order)
    };

    handleClick = (event, id)=> {
    }

    handleSearch=(search)=>{
    }

    render() {
        const { imgSegment } = this.props;
        const { task,imgSegmentQuestion,imgSegmentDataset } = imgSegment;
        let nextWorkflowUrl=''

        if (!task || !imgSegmentQuestion || !imgSegmentDataset){ 
            return (
                <div className="container">
                    <div className='row'>
                        <br />
                    </div>
                    <div className='row'>
                        <div className='col-sm'>
                            <h4>{task?task.task_name:''}</h4>
                        </div>    
                    </div>
                    <div className='row'>
                        <br />
                    </div>
                    <div className='row'>
                        <div className='col-sm'>
                            <h5>Loading...</h5>
                        </div>
                    </div>
                </div>    
            )
        }

        if (task && imgSegmentQuestion && imgSegmentDataset){
            const { jwt,taskAcceptedInfoId } = imgSegment.query;
            //const taskParamValues=JSON.parse(task.task_param_values) 
            const taskParamValues=task.task_param_values 
            
            nextWorkflowUrl=taskParamValues.nextWorkflowUrl;
            nextWorkflowUrl+=`?taskAcceptedInfoId=${taskAcceptedInfoId}`
            nextWorkflowUrl+=`&currentFrame=${imgSegmentDataset.task_seq}`
            nextWorkflowUrl+=`&totalFrames=${imgSegmentQuestion.answer_total_obj_detected}`
            nextWorkflowUrl+=`&imgSegmentDatasetId=${imgSegmentDataset.id}`
            nextWorkflowUrl+=`&imgType=${imgSegmentQuestion.in_img_type}`
            nextWorkflowUrl+=`&imgUrl=${imgSegmentQuestion.in_img_url}`
            nextWorkflowUrl+=`&imgOrgSrcName=${imgSegmentQuestion.in_org_src_name}`
            nextWorkflowUrl+=`&apiHost=${taskParamValues.apiHost}`
            nextWorkflowUrl+=`&taskName=${encodeURIComponent(task.task_name)}`
            nextWorkflowUrl+=`&jwt=${jwt}`
        }

        let progress=(imgSegmentQuestion.total_obj_segmented/imgSegmentQuestion.answer_total_obj_detected) * 100;
        if (!isNaN(progress)){
            progress=Math.ceil(progress);
        }
        return (
            <div className="container">
                <div className='row'>
                    <br />
                </div>
                <div className='row'>
                    <div className='col-sm'>
                        <h4>{imgSegment.task.task_name}</h4>
                    </div>    
                </div>
                <div className='row'>
                    <br />
                </div>
                <div className='row'>
                    <div className='col-sm'>
                        <div className="smallImage">
                            <img src={imgSegmentQuestion.in_img_url}  />
                        </div>
                    </div>  
                </div>    
                <div className='row'>
                    <div className='col-sm'>
                        <span className="label label-default">{`Your progress ${imgSegmentQuestion.total_obj_segmented}/${imgSegmentQuestion.answer_total_obj_detected}`}</span>
                        <div className="progress">
                            <div className="progress-bar" role="progressbar" style={{width: `${progress}%`}} aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100">{progress}%</div>
                        </div>
                    </div> 
                </div>    
                <div className='row'>
                    <br />
                </div>
                <div className='row'>
                    <div className='col-sm'>
                        <a href={nextWorkflowUrl}>
                            <button className="btn btn-primary btn-lg" type="button" >
                             Click here to perform image segmentation
                            </button>
                        </a>
                    </div>    
                </div>    
                <div className='row'>
                    <br />
                </div>
                <div className='row'>
                    <div className='col-sm'>
                         <SwarmColonyDataTable 
                            title={'Your Answers'}    
                            totalRows={imgSegment.count}
                            order={imgSegment.sortOrder}
                            orderBy={imgSegment.sortField}
                            rowsPerPage={imgSegment.pageSize}
                            page={imgSegment.page - 1}
                            data={imgSegment.imgSegmentDatasets}
                            //handleSearch={this.handleSearch}
                            columnData={columnData}
                            handleRequestSort={this.handleRequestSort}
                            handleClick={this.handleClick}
                            handleChangePage={this.handleChangePage}
                            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                            tableStyle={{width: '100%',minWidth: 800}}
                            customColFunc={customCol}
                            showToolbar={true}
                            clientUiProps={this.props}    
                        />
                    </div>
                </div>
            </div>    
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        imgSegment: state.imgSegment
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getCurrentSegmentQuestion: (jwt,taskAccessKey) => {
            dispatch(actions.getCurrentSegmentQuestion(jwt,taskAccessKey))  
        },
        getNextImageSegmentDataset: (jwt,imgSegmentQuestionId) => {
            dispatch(actions.getNextImageSegmentDataset(jwt,imgSegmentQuestionId))  
        },
        getImgSegmentDatasets: (jwt,page,pageSize,sortField,sortOrder,imgSegmentQuestionId) => {
            dispatch(actions.getImgSegmentDatasets(jwt,page,pageSize,sortField,sortOrder,imgSegmentQuestionId))  
        },
        setPage: (jwt,imgSegment,page) => {
            dispatch(actions.setPage(jwt,imgSegment,page))  
        },
        setPageSize: (jwt,imgSegment,pageSize) => {
            dispatch(actions.setPageSize(jwt,imgSegment,pageSize))  
        },
        sortData: (jwt,imgSegment,sortField,sortOrder) => {
            dispatch(actions.sortData(jwt,imgSegment,sortField,sortOrder))  
        }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(ImageSegmentAckTaskContinue);


// WEBPACK FOOTER //
// ./src/views/ImageSegmentQuestion/ImageSegmentAckTaskContinue.js